import { render, staticRenderFns } from "./novellistdialog.vue?vue&type=template&id=ad5f2082&scoped=true"
import script from "./novellistdialog.vue?vue&type=script&lang=js"
export * from "./novellistdialog.vue?vue&type=script&lang=js"
import style0 from "./novellistdialog.vue?vue&type=style&index=0&id=ad5f2082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5f2082",
  null
  
)

export default component.exports